/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Button from "../../base/ui/components/web/Button";
import { BUTTON_TYPES } from "../../base/ui/constants.any";
import { joinConference } from "../actions.web";
const useStyles = makeStyles()(theme => {
    return {
        container: {
            gridArea: 'button',
            alignSelf: 'center',
            justifySelf: 'flex-end',
            paddingRight: '16px',
        },
        button: {},
    };
});
const PrejoinJoinButton = ({ joiningInProgress }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onClick = () => {
        dispatch(joinConference());
    };
    return (React.createElement("div", { className: classes.container },
        React.createElement(Button, { className: classes.button, accessibilityLabel: t('lobby.previewWindow.button'), labelKey: t('lobby.previewWindow.button'), disabled: joiningInProgress, onClick: onClick, role: 'button', tabIndex: 0, testId: 'lobby.previewWindow.button', type: BUTTON_TYPES.PRIMARY })));
};
function mapStateToProps(state) {
    const { joiningInProgress } = state['features/prejoin'];
    return {
        joiningInProgress: joiningInProgress ?? false,
    };
}
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PrejoinJoinButton);
